
import React, { useState } from 'react';
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  pointerWithin,
  useDraggable,
  useDroppable,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import styled from 'styled-components';


const OverlayCard = styled.div`
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(51, 51, 51, 0.16);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: grabbing;
`;


function VehicleOverlay({ vehicle }) {
  const slot = vehicle.start_slot || {};
  const detail = vehicle.detail || slot.tractor_unit || {};
  return (
    <OverlayCard>
      {detail.number_display || detail.number || 'ТС'}
    </OverlayCard>
  );
}


export function PlanningDndProvider({ children, onDropVehicle, disabled }) {
  const [activeVehicle, setActiveVehicle] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 8 },
    })
  );

  const handleDragStart = (event) => {
    setActiveVehicle(event.active.data.current?.vehicle || null);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveVehicle(null);
    if (disabled || !over) {
      return;
    }
    const vehicle = active.data.current?.vehicle;
    const order = over.data.current?.order;
    if (vehicle && order) {
      onDropVehicle(order, vehicle);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={pointerWithin}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={() => setActiveVehicle(null)}
    >
      {children}
      <DragOverlay dropAnimation={null}>
        {activeVehicle && <VehicleOverlay vehicle={activeVehicle} />}
      </DragOverlay>
    </DndContext>
  );
}


export function useVehicleDraggable(vehicle, disabled) {
  const slotId = vehicle.start_slot ? vehicle.start_slot.id : vehicle.detail.id;
  return useDraggable({
    id: `vehicle-${slotId}`,
    data: { type: 'free-vehicle', vehicle },
    disabled,
  });
}


export function useOrderDroppable(order, disabled) {
  return useDroppable({
    id: `order-${order.id}`,
    data: { type: 'order', order },
    disabled,
  });
}
